import Menu from './Menu';

const config = {
  name: 'siteMenu',
  class: Menu,
  querySelector: {},
  querySelectorAll: {
    menus: '.menu-item-has-children',
  },
  options: {
    subMenuSelector: '.sub-menu',
    // For options,
    // @see https://github.com/alleyinteractive/js-component-framework/blob/master/src/plugins/AriaPopup.js#L17
    // ariapopup: {},
  },
};

export default config;
